import { WorkloadCaseEntity } from './workload-case.entity';
import { WorkloadTimeOffBlockEntity } from './workload-time-off-block.entity';

export class WorkloadMemberDetailEntity {
  public userId!: string;
  public firstName!: string;
  public lastName!: string;
  public email!: string;
  public baseCapacity!: number;
  public temporaryCapacity!: number | null;
  public temporaryCapacityExpiresOn!: string | null;
  public effectiveCapacity!: number;
  public currentCaseCount!: number;
  public activeCases!: WorkloadCaseEntity[];
  public closedCases!: WorkloadCaseEntity[];
  public upcomingTimeOff!: WorkloadTimeOffBlockEntity[];
}
